import lang from "translations";

export const VoucherTransactionReportColumns = [
  {
    key: "voucherId",
    text: lang.voucherId,
  },
  {
    key: "voucherType",
    text: lang.voucherType,
  },
  {
    key: "checkinId",
    text: lang.checkinId,
  },
  {
    key: "customerName",
    text: lang.customerName,
  },
  {
    key: "issueDate",
    text: lang.issueDate,
  },
  {
    key: "amount",
    text: lang.amount,
  }
];

  // Columns for RefundVoucherDetailResponse
  export const RefundVoucherDetailColumns = [
    { key: "transactionId", text: lang.transactionId },
    { key: "voucherId", text: lang.voucherId },
    { key: "voucherDate", text: lang.date },
    { key: "guestName", text: lang.guestName },
    { key: "guestTagUid", text: lang.guestTagUid },
    { key: "tagUseCount", text: lang.tagUseCount },
    { key: "voucherType", text: lang.voucherType },
    { key: "amount", text: lang.amount },
  ];

// Columns for TopupVoucherDetailResponse
export const TopupVoucherDetailColumns = [
  { key: "transactionId", text: lang.transactionId },
  { key: "voucherDate", text: lang.voucherDate },
  { key: "guestName", text: lang.guest },
  { key: "voucherType", text: lang.voucherType },
  { key: "amount", text: lang.amount },
];


// Columns for RefundVoucherDetailResponse
export const AdjustmentVoucherDetailColumns = [
  { key: "transactionId", text: lang.transactionId },
  { key: "voucherId", text: lang.voucherId },
  { key: "voucherDate", text: lang.date },
  { key: "guestName", text: lang.guestName },
  { key: "guestTagUid", text: lang.guestTagUid },
  { key: "tagUseCount", text: lang.tagUseCount },
  { key: "voucherType", text: lang.voucherType },
  { key: "amount", text: lang.amount },
];